import videoThumbGeral from "../modules/Utils/video_thumb_geral";

videoThumbGeral();

document.addEventListener('DOMContentLoaded', function () {
    // swiper
    const swiperThumbs = new Swiper('.swiper-thumbs', {
        slidesPerView: 1,
        loop: false,
        spaceBetween: 26,
        
        breakpoints: {
            992: {
                slidesPerView: 4,
                loop: true,
                
                autoplay: {
                    delay: 6000,
                    disableOnInteraction: false,
                },
            },
        },
    });

    const swiperVideos = new Swiper('.swiper-videos', {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 15,

        thumbs: {
            swiper: swiperThumbs,
        },
    });
});